module.exports = __webpack_public_path__ + "media/src/images/phone-p-500x1019-6d5cba24ff74e9fc4265ad105e5e8147.png";